import { useEffect, useRef } from 'react'

export const useDirectContactFormOpenLoginModalForLoggedOutOrderSubject = ({
  isContactFormOpen,
  isLoggedIn,
  onOpen,
  selectedSubject,
  shouldOpenLoginModal,
}: {
  isContactFormOpen: boolean
  isLoggedIn: boolean
  onOpen: () => void
  selectedSubject: string
  shouldOpenLoginModal: boolean
}): void => {
  const previousSubject = useRef<string | undefined>(undefined)

  useEffect(() => {
    if (!isContactFormOpen) {
      return
    }

    const hasSubjectChanged = previousSubject.current !== selectedSubject
    previousSubject.current = selectedSubject

    if (shouldOpenLoginModal && !isLoggedIn && hasSubjectChanged) {
      onOpen()
    }
  }, [
    isContactFormOpen,
    isLoggedIn,
    onOpen,
    selectedSubject,
    shouldOpenLoginModal,
  ])
}
